import axios from 'axios';
import { ApiResponse } from '../../../ts';
import { CloneQuoteParams } from 'src/ts/interfaces/quotes/clone-quote-params';

export const cloneQuoteService = async (cloneQuoteParams: CloneQuoteParams) => {
  const response = await axios.post<ApiResponse<any>>('/patients/clone-quote', cloneQuoteParams);

  const { data } = response;

  if (data.isOk !== true) {
    throw new Error('Error setting audio as listened');
  }

  return data.data;
};
